import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { errorNotification } from "../Generic/Notifications";
import { AppRoutes, DashboardModules } from "../config/app.config";
import { OfferField, OfferFormMode } from "./constants";
import OfferFormWizard from "./Components/OfferFormWizard";
import { useOfferContext } from "./context/OfferContext";
import OffersService from "./Services/OffersService";
import { mapOfferDraftToPayload } from "./utils/offerApiMapping";
import { canGoBackInSession } from "./utils/offersListFilters";

const OFFERS_ROUTES = AppRoutes[DashboardModules.OFFERS];

const OfferEdit = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const {
		editingOffer,
		editingOfferBaseline,
		updateEditingOfferDraft,
		clearEditingOffer,
		clearOffersList,
	} = useOfferContext();
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		return () => {
			clearEditingOffer();
		};
	}, [clearEditingOffer]);

	function handleCancel() {
		if (canGoBackInSession()) {
			navigate(-1);
			return;
		}
		const path = id ? OFFERS_ROUTES.DETAILS.getPath(id) : OFFERS_ROUTES.LIST.getPath();
		navigate(path);
	}

	async function submitOffer() {
		if (!editingOffer || !id) return;
		setSubmitting(true);
		try {
			const payload = mapOfferDraftToPayload(
				editingOffer,
				editingOffer[OfferField.STATUS]
			);
			const { error } = await OffersService.updateOffer(id, payload);
			if (error) {
				errorNotification(error);
				return;
			}
			clearOffersList();
			if (canGoBackInSession()) {
				navigate(-1);
			} else {
				navigate(OFFERS_ROUTES.DETAILS.getPath(id), { replace: true });
			}
		} catch {
			errorNotification("Failed to update offer");
		} finally {
			setSubmitting(false);
		}
	}

	if(!editingOffer) {
		navigate(OFFERS_ROUTES.DETAILS.getPath(id), { replace: true });
	}

	return (
		<OfferFormWizard
			title="Edit Offer"
			submitLabel="Save Changes"
			draft={editingOffer}
			baseline={editingOfferBaseline}
			mode={OfferFormMode.EDIT}
			onDraftChange={updateEditingOfferDraft}
			onSubmit={submitOffer}
			onCancel={handleCancel}
			submitting={submitting}
		/>
	);
};

export default OfferEdit;
